import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);
const routes = [
    {
        path: '/',
        redirect: localStorage.getItem('user_type') == 'user' ? '/detail':'/dashboard' 
    },
    { 
        path: '/',
        component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
        meta: { title: '自述文件' },
        children: [
            {
                path: '/dashboard',
                component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Dashboard.vue'),
                meta: { title: '仪表盘' }
            },
           
            {
                path: '/user',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/user.vue'),
                meta: { title: '用户管理' }
            },
            {
                path: '/detail',
                component: () => import(/* webpackChunkName: "tabs" */ '../components/page/detail.vue'),
                meta: { title: '数据明细' }
            },
          
            {
                path: '/dispose',
                component: () => import(/* webpackChunkName: "form" */ '../components/page/dispose.vue'),
                meta: { title: '奖励配置' }
            },
            {
                path: '/activation',
                component: () => import(/* webpackChunkName: "upload" */ '../components/page/activation.vue'),
                meta: { title: '奖励激活' }
            },
            {

                path: '/product',
                component: () => import(/* webpackChunkName: "editor" */ '../components/page/product.vue'),
                meta: { title: '产品管理' }
            },
            {
                path: '/staff',
                component: () => import(/* webpackChunkName: "markdown" */ '../components/page/staff.vue'),
                meta: { title: '员工设置' }
            },
            {
                path: '/binding',
                component: () => import(/* webpackChunkName: "dragdialog" */ '../components/page/binding.vue'),
                meta: { title: '绑定明细' }
            },
            {
   
                path: '/record',
                component: () => import(/* webpackChunkName: "i18n" */ '../components/page/record.vue'),
                meta: { title: '修改日志' }
            },
            {
   
                path: '/unknown',
                component: () => import(/* webpackChunkName: "i18n" */ '../components/page/unknown.vue'),
                meta: { title: '未知用户' }
            },
           
        ]
    },
    {
        path: '/login',
        component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
        meta: { title: '登录' },
    }
    
];

//使用钩子函数对路由进行权限跳转
const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
});
router.beforeEach((to, from, next) => {
    const role = localStorage.getItem('token');
    if (!role && to.path !== '/login') {
        next('/login');
    } else {
        next();
    }
    

});
export default router;
